export const SELECTED_ENHET_ID = 'SELECTED_ENHET_ID';
